(function () {
  var PHONE = '+359894567570';
  var BOTTOM_OFFSET_MOBILE = 80;
  var BOTTOM_OFFSET_DESKTOP = 50;
  var SIDE_OFFSET = 25;
  var SIZE = 60;
  var BG = '#25D366';
  var HOVER_BG = '#1ebe5a';
  var ICON_COLOR = '#ffffff';
  var PULSE = true;

  var style = document.createElement('style');
  style.textContent = `
    #fcb-btn {
      position: fixed;
      bottom: ${BOTTOM_OFFSET_DESKTOP}px;
      right: ${SIDE_OFFSET}px;
      z-index: 9999;
      width: ${SIZE}px;
      height: ${SIZE}px;
      background: ${BG};
      color: ${ICON_COLOR};
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 12px rgba(0,0,0,.2);
      transition: transform .25s ease, box-shadow .25s ease, background .25s ease;
      text-decoration: none;
    }
    #fcb-btn:hover {
      transform: scale(1.1);
      background: ${HOVER_BG};
      box-shadow: 0 6px 18px rgba(0,0,0,.3);
    }
    #fcb-btn svg { width: 50%; height: 50%; fill: currentColor; }
    ${PULSE ? `
    #fcb-btn::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 50%;
      background: ${BG};
      animation: fcb-pulse 2s infinite;
      z-index: -1;
    }
    @keyframes fcb-pulse {
      0%   { transform: scale(1);   opacity: .7; }
      70%  { transform: scale(1.5); opacity: 0;  }
      100% { transform: scale(1.5); opacity: 0;  }
    }` : ''}
    @media (max-width: 991px) {
      #fcb-btn { bottom: ${BOTTOM_OFFSET_MOBILE}px; }
    }
    @media (max-width: 749px) {
      #fcb-btn { width: ${Math.round(SIZE * 0.85)}px; height: ${Math.round(SIZE * 0.85)}px; }
    }
  `;
  document.head.appendChild(style);

  var a = document.createElement('a');
  a.id = 'fcb-btn';
  a.href = 'tel:' + PHONE;
  a.setAttribute('aria-label', 'Обадете ни се');
  a.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.02-.24 11.36 11.36 0 003.57.57 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.36 11.36 0 00.57 3.57 1 1 0 01-.25 1.02l-2.2 2.2z"/></svg>';
  document.body.appendChild(a);
})();